import { forwardRef, type InputHTMLAttributes, type MouseEvent } from 'react';

export type DateInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

export const DateInput = forwardRef<HTMLInputElement, DateInputProps>(function DateInput(
  { onClick, ...props },
  ref,
) {
  function openPicker(event: MouseEvent<HTMLInputElement>) {
    onClick?.(event);
    if (event.defaultPrevented) return;
    try {
      event.currentTarget.showPicker?.();
    } catch {
      event.currentTarget.focus();
    }
  }

  return <input {...props} ref={ref} type="date" onClick={openPicker} />;
});
